export const REGISTRATION_URL = "https://app.fedefitnessitalia.com/deserto";
